import React from 'react';

export default function UploadIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="30" height="30" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M40 0C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8C5.15405e-07 3.58172 3.58172 0 8 0H40Z"
                fill="#E5E7EB"
            />
            <path
                d="M40 0C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8C5.15405e-07 3.58172 3.58172 0 8 0H40Z"
                stroke="#E5E7EB"
            />
            <path d="M36.5 34H11.5V14H36.5V34Z" stroke="#E5E7EB" />
            <g clipPath="url(#clip0_7364_5140)">
                <path
                    d="M17.125 32.75C14.0195 32.75 11.5 30.2305 11.5 27.125C11.5 24.6719 13.0703 22.5859 15.2578 21.8164C15.2539 21.7109 15.25 21.6055 15.25 21.5C15.25 18.0469 18.0469 15.25 21.5 15.25C23.8164 15.25 25.8359 16.5078 26.918 18.3828C27.5117 17.9844 28.2305 17.75 29 17.75C31.0703 17.75 32.75 19.4297 32.75 21.5C32.75 21.9766 32.6602 22.4297 32.5 22.8516C34.7812 23.3125 36.5 25.332 36.5 27.75C36.5 30.5117 34.2617 32.75 31.5 32.75H17.125ZM20.2109 24.2734C19.8438 24.6406 19.8438 25.2344 20.2109 25.5977C20.5781 25.9609 21.1719 25.9648 21.5352 25.5977L23.0586 24.0742V29.3125C23.0586 29.832 23.4766 30.25 23.9961 30.25C24.5156 30.25 24.9336 29.832 24.9336 29.3125V24.0742L26.457 25.5977C26.8242 25.9648 27.418 25.9648 27.7812 25.5977C28.1445 25.2305 28.1484 24.6367 27.7812 24.2734L24.6562 21.1484C24.2891 20.7812 23.6953 20.7812 23.332 21.1484L20.207 24.2734H20.2109Z"
                    fill="#9CA3AF"
                />
            </g>
            <defs>
                <clipPath id="clip0_7364_5140">
                    <path d="M11.5 14H36.5V34H11.5V14Z" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
